import { Component, Input, EventEmitter, Output, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { LevelAsset, AssetsDataService, ILevelAsset } from '@services/assets-data.service';
import { EditHierarchyAssetComponent } from '../../../dialogs/edit-level-asset/edit-level-asset.component';
import { Subject, distinctUntilChanged, filter, finalize, takeUntil } from 'rxjs';
import { GlobalFunctions, SnackType, imagePath, imgTypes } from '@global/GlobalFunctions';
import { IOrganisationsHierarchy, OrganisationDataService } from '@services/organisation-data.service';
import { siteSubscriptions } from '@services/siteSubscriptions';

/**
 * Component
 */
@Component({
	selector: 'app-hierarchy-asset',
	templateUrl: './hierarchy-asset.component.html',
	styleUrls: ['./hierarchy-asset.component.scss']
})
export class HierarchyAssetComponent {

	/** Path to Assets Images */
	public imagePathAssets(): string {
		return imagePath(this.accountID, imgTypes.organisationassets).toLowerCase()
	}

	/** asset */
	@Input() asset: LevelAsset
	/** accountID */
	@Input() accountID: string;
	/** OrganisationID */
	@Input() OrganisationID: string;
	/** selected */
	@Output() selected: EventEmitter<ILevelAsset> = new EventEmitter<ILevelAsset>();

	/**
	 * Default Constructor
	 * @param dialog dialog
	 * @param assetsData assetsDataService
	 * @param organisationDataService OrganisationDataService
	 * @param globalFunctions globalFunctions
	 * @param siteSubscriptions siteSubscriptions
	 */
	constructor(
		public dialog: MatDialog,
		private assetsData: AssetsDataService,
		private organisationDataService: OrganisationDataService,
		private globalFunctions: GlobalFunctions,
		private siteSubscriptions: siteSubscriptions
	) { }

	/**
	 * triggerEvent
	 * @param Asset
	 */
	triggerEvent(Asset: ILevelAsset) {
		// Optionally, you can pass data along with the event
		const eventData: ILevelAsset = Asset;
		this.selected.emit(eventData);
	}

	/**
	 * Edit the Company details
	 * @param editAsset
	 */
	editAsset(editAsset: ILevelAsset): void {
		// Create a local Subject to control the subscription lifecycle
		const fetchDataSubject = new Subject<void>();

		// Create a 'Local'/shallow copy of the Asset Information
		var _edit = { ...editAsset };

		// Display the dialog box
		const dialogRef = this.dialog.open(EditHierarchyAssetComponent, {
			data: _edit,
		});

		// Update the original Asset with the result
		dialogRef.afterClosed().pipe(
			filter(result => !!result)
		).subscribe(result => {
			// console.log('The dialog was closed');
			// Check we have a result to work with
			Object.assign(_edit, result);
			this.assetsData.patchOrganisationAssets$(this.accountID, this.OrganisationID, _edit).pipe(
				takeUntil(fetchDataSubject), distinctUntilChanged(),
				filter((response) => !!response),
				finalize(() => {
					// Ensure the subscription is terminated and the subject is completed
					fetchDataSubject.next();
					fetchDataSubject.complete();
				})
			).subscribe({
				next: (response) => {
					Object.assign(editAsset, result);
					this.subscribeOrganisationStructure(this.accountID, this.OrganisationID)
					this.globalFunctions.DisplaySnackBar({
						message: "Asset Details Updated",
						type: SnackType.Info,
						duration: 1000
					});
				}
			});
		});
	}

	/**
	 * Get the Organisation Structure
	 * @param AccountID AccountID
	 * @param OrganisationID OrganisationID
	 */
	subscribeOrganisationStructure(AccountID: string, OrganisationUID: string) {
		// Create a local Subject to control the subscription lifecycle
		const fetchDataSubject = new Subject<void>();

		try {
			/** Get the Organisation for the selection */
			this.organisationDataService.getOrganisationStructure$(AccountID, OrganisationUID).pipe(
				takeUntil(fetchDataSubject), distinctUntilChanged(),
				filter((structure) => !!structure),
				finalize(() => {
					// Ensure the subscription is terminated and the subject is completed
					fetchDataSubject.next();
					fetchDataSubject.complete();
				})
			).subscribe({
				next: (structure: any) => {
					try {
						/** Update the Organisation */
						var OrganisationStructure = <IOrganisationsHierarchy[]>JSON.parse(structure);
						this.siteSubscriptions.SethierarchicalData(OrganisationStructure);
					} catch (error) { console.error(error); }
				},
				error: (error) => {
					if (error["status"] != 404) {
						this.globalFunctions.HandleError(error, "Error: organisationDataService.getOrganisationStructure$(OrganisationUID).subscribe$", false)
					}
				},
				//complete: () => { console.log("organisationDataService.getOrganisationStructure$(OrganisationUID).subscribe: Complete"); }
			});
		} catch (error) { console.error(error); }
	}
}
